import React, { useLayoutEffect } from 'react'

import Box from '@material-ui/core/Box'
import Fab from '@material-ui/core/Fab'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import mixpanel from 'mixpanel-browser'
import Error from 'components/svg/error'

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: '5%',
  },
  item: {
    paddingTop: '1%',
  },
  fab: {
    margin: theme.spacing(1),
    marginBottom: '5rem',
    backgroundColor: '#00aeef',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#009deb',
    },
  },
  icon: {
    marginRight: theme.spacing(1),
    fontSize: '24px',
  },
}))

function ErrorState() {
  const classes = useStyles()

  useLayoutEffect(() => {
    mixpanel.track_pageview({ page: 'Tela de erro Genérico' }, { event_name: 'Acesso - Feedback de erro genérico' })
  }, [])

  return (
    <Grid container className={classes.container} direction="column" justifyContent="space-between" alignItems="center">
      <Grid item xs={12} className={classes.item}>
        <Error />
      </Grid>
      <Grid item xs={3} className={classes.item}>
        <Typography component="div">
          <Box textAlign="center" fontWeight="fontWeightBold" fontSize={19} m={1}>
            Oh-oh! Algo deu errado :(
          </Box>
        </Typography>
      </Grid>
      <Grid item xs={6} className={classes.item}>
        <Typography component="div">
          <Box textAlign="center" fontSize={16} m={1}>
            Parece que tivemos um problema ao carregar esta página. Tente carregá-la novamente, se o problema persistir
            entre em contato através do e-mail servicedesk@hiplatform.com
          </Box>
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.item}>
        <Fab
          variant="extended"
          aria-label="delete"
          className={classes.fab}
          onClick={() => window.location.reload()}
          data-testid="btn-refresh"
        >
          <span className={`icon-refresh ${classes.icon}`} />
          RECARREGAR PÁGINA
        </Fab>
      </Grid>
    </Grid>
  )
}

export default ErrorState
